// @ts-nocheck
import React, { useCallback, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
} from '@mui/material';
import PropTypes from 'prop-types';
import { ReactComponent as CloseIcon } from '../../../assets/Icons/lucideIcons/x.svg';

/**
 * @typedef IFrameModalProps
 * @property {'youtube' | 'iframe'} mode
 * @property {(url: string) => void} onSubmit
 */

const title = {
  youtube: 'Enter YouTube URL',
  iframe: 'Enter Embed URL',
};

/**
 * @param {IFrameModalProps & import("@mui/material").DialogProps} props
 */
const IFrameModal = ({ mode, onClose, onSubmit, ...props }) => {
  const [url, setURL] = useState('');
  const handleSubmit = useCallback(
    (e) => {
      onSubmit(url);
      onClose(e, 'escapeKeyDown');
      setURL('');
    },
    [onSubmit, onClose, url, setURL]
  );

  const handleClose = useCallback(
    (e) => {
      setURL('');
      onClose(e, 'escapeKeyDown');
    },
    [setURL, onClose]
  );

  const handleURLChange = useCallback(
    (e) => setURL(e?.target?.value),
    [setURL]
  );

  return (
    <Dialog onClose={handleClose} {...props}>
      <DialogTitle>
        <Box component="span" aria-live="polite" aria-atomic="true">
          {title[mode]}
        </Box>
      </DialogTitle>

      <IconButton
        aria-label="Close dialog"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 16,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Grid container>
          <Grid size={12}>
            {' '}
            <TextField
              label="URL"
              placeholder="Enter URL"
              value={url}
              onChange={handleURLChange}
              required
              spellCheck={true}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="outlined" title="Cancel">
          Cancel
        </Button>
        <Button variant="contained" title="Add" onClick={handleSubmit}>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};
IFrameModal.propTypes = {
  mode: PropTypes.oneOf(['youtube', 'iframe']).isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default IFrameModal;
